import React from 'react';
import { useTranslation } from '@app/core/i18n';

import { PasswordFieldFragment } from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import { isPasswordField } from '@app/common/configurable-wizards/utils';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards';
import { FormSectionTitle } from '../common/FormSectionTitle';
import { NewPasswordFieldComponent } from '.';

export const NewPasswordFieldWithTitleComponent: FieldComponent<PasswordFieldFragment> = ({
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <FormSectionTitle
        title={t('new-password-field.title|Create your password - section title', 'Create your password')}
      />
      <NewPasswordFieldComponent {... props} />
    </div>
  );
};

export const NewPasswordFieldWithTitleLocator: FieldLocator = ({ field }) => (
  (isPasswordField(field))
    ? NewPasswordFieldWithTitleComponent
    : undefined
);
